<template>
  <PComponentLoader :loading="loading">
    <div v-if="!loading">
    <CContainer>
      <div class="grid-stripped">
        <PFRow :label="$pgettext('vertical_configuration.label', 'Category')">
          <CSelect v-model="form.category" :options="categories"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Codec')">
          <CSelect v-model="form.codec" :options="codecs"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Magic Tag Enabled')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.is_magictag_enabled"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Autotag Enabled')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.is_autotag_enabled"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Allow User Inference')"
               help-text="When enabled, users can manually trigger face inference to find more photos">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.allow_user_inference"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Priority Recognition')">
          <CSelect v-model="form.priority_recognition" :options="processingPriority"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Priority Upload')">
          <CSelect v-model="form.priority_upload" :options="processingPriority"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Recognition Class')">
          <CSelect v-model="form.recognition_class" :options="recognitionClasses"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Use Adaptive Face Match Confidence')"
               help-text="When enabled, the system will dynamically select the face match confidence based on face attributes instead of using the fixed face_match_min_confidence value.">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.use_adaptive_face_match_confidence"/>
        </PFRow>
        <template v-if="!form.use_adaptive_face_match_confidence">
          <PFRow :label="$pgettext('vertical_configuration.label', 'Face Match - min confidence (0.00 - 1.00)')">
            <CInput v-model="form.face_match_min_confidence" type="number" min="0" step="0.01"/>
          </PFRow>
        </template>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Face Recognition - min confidence (0.00 - 1.00)')">
            <CInput v-model="form.face_recognition_min_confidence" type="number" min="0" step="0.01"/>
          </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Num selfies (1 = no multy-selfy)')">
          <CInput v-model="form.checkin_max_faces_count" type="number" min="1"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Checkin Stay Mode')">
          <CSelect v-model="form.checkin_stay_mode" :options="checkinStayMode"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Allow upload from mobile')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.allows_upload_from_mobile"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Require a Welcome Code')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.requires_welcome_code"/>
        </PFRow>
        <template v-if="form.requires_welcome_code">
          <PFRow :label="$pgettext('vertical_configuration.label', 'Auto generate welcome code at publish')">
            <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                     :checked.sync="form.auto_generate_welcome_code"/>
          </PFRow>
          <template v-if="!form.auto_generate_welcome_code">
            <PFRow :label="$pgettext('vertical_configuration.label', 'Allows custom welcome code')">
              <CSwitch class="mx-1" color="primary"
                       variant="3d" size="sm"
                       :checked.sync="form.allows_custom_welcome_code"/>
            </PFRow>
          </template>
        </template>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Allow TimeLine in browse photo')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.allows_browse_photo_timeline"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Allow upload HD')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.allows_upload_hd"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Allow upload video')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.allows_upload_video"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Has media original')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.has_media_original"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Anonymize Mode')">
          <CSelect v-model="form.checkin_anonymize_mode" :options="anonymizeMode"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Experience Type')">
          <CSelect v-model="form.experience_type" :options="experienceType"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Prevent checkin for existing faces')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.prevent_checkins_for_existing_faces"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Purchase Time')">
          <CSelect v-model="form.purchase_time" :options="purchaseTime"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Display Time')">
          <CSelect v-model="form.display_time" :options="displayTime"/>
        </PFRow>
        <PFRow
            :label="$pgettext('vertical_configuration.label', 'Face reassignment allowed')"
            help-text="When enabled, faces already assigned to a FaceCheckin can be reassigned">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.is_face_reassignment_allowed"/>
        </PFRow>
        <PFRow
            :label="$pgettext('vertical_configuration.label', 'Disable slave checkin')"
            help-text="Only one user will be able to check-in">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.checkin_slave_disabled"/>
        </PFRow>
        <PFRow
            :label="$pgettext('vertical_configuration.label', 'Generate anonymous user')"
            help-text="If enabled, the user will be created with an anonymous email address">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.generate_anon_user"/>
        </PFRow>
        <PFRow
            :label="$pgettext('vertical_configuration.label', 'Show external orders')"
            help-text="If enabled, external orders will be shown in the orders page">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.show_external_orders"/>
        </PFRow>
        <PFRow
            :label="$pgettext('vertical_configuration.label', 'Use gallery tree')"
            help-text="When enabled, the gallery tree will be used to organize the photos instead of the multy-gallery mode">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.use_gallery_tree"/>
        </PFRow>
        <PFRow
            :label="$pgettext('vertical_configuration.label', 'Allows overview')"
            help-text="When enabled, the overview section will be visible in the event wizard">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.allows_overview"/>
        </PFRow>
        <PFRow size="12x12"><h6>Video Recognition</h6></PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Video Sample FPS')"
               help-text="Frame to sample for every second (0.1 -3.0)">
          <CInput v-model="form.video_sample_fps" type="number" min="0.1" max="3.0" step="0.1"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Thumb Position in seconds')"
               help-text="Time in seconds from the start of the video to extract the thumbnail">
          <CInput v-model="form.video_thumb_sec" type="number" step="0.1"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Begin Offset')"
               help-text="Offset in seconds from the start of the video to begin face detection">
          <CInput v-model="form.video_rec_offset1" type="number" step="0.1"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'End Offset')"
               help-text="Offset in seconds from the end of the video to stop face detection">
          <CInput v-model="form.video_rec_offset2" type="number" step="0.1"/>
        </PFRow>
        <PFRow :label="$pgettext('vertical_configuration.label', 'Transcode')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.video_transcode"/>
        </PFRow>
      </div>
    </CContainer>
    <div class="d-flex justify-content-end p-3 border-top">
      <CButton color="success" variant="outline" @click="onReset" ref="reset-button" class="mr-2"
               v-translate translate-context="event_wizard">
        Reset
      </CButton>
      <PButton color="primary" @click="onSave">
        <translate translate-context="event_wizard">Save</translate>
      </PButton>
    </div>
    </div>
  </PComponentLoader>
</template>

<script>
import PFRow from "@/domain/core/components/PFRow.vue";
import {mapActions, mapGetters} from "vuex";
import PButton from "@/components/PButton.vue";
import PComponentLoader from "@/domain/core/components/PComponentLoader.vue";

export default {
  name: "StepVertical",
  components: {PComponentLoader, PButton, PFRow},
  props: {
  },
  data() {
    return {
      form: {
        category: null,
        codec: 'FaceRecognition262kCodec',
        is_magictag_enabled: null,
        is_autotag_enabled: false,
        allow_user_inference: false,
        priority_recognition: null,
        priority_upload: null,
        recognition_class: 'person',
        face_recognition_min_confidence: 0.95,
        face_match_min_confidence: 0.97,
        use_adaptive_face_match_confidence: false,
        checkin_max_faces_count: null,
        checkin_stay_mode: null,
        allows_upload_from_mobile: false,
        allows_custom_welcome_code: false,
        requires_welcome_code: false,
        auto_generate_welcome_code: false,
        allows_browse_photo_timeline: false,
        allows_upload_hd: false,
        allows_upload_video: false,
        has_media_original: false,
        checkin_anonymize_mode: 'blur',
        experience_type: 'p',
        prevent_checkins_for_existing_faces: false,
        purchase_time: 'at',
        display_time: 'at',
        is_face_reassignment_allowed: false,
        checkin_slave_disabled: true,
        generate_anon_user: false,
        show_external_orders: false,
        use_gallery_tree: false,
        allows_overview: true,
        video_sample_fps: 1.0,
        video_thumb_sec: 3.0,
        video_rec_offset1: 0.0,
        video_rec_offset2: 0.0,
        video_transcode: true,
      }
    }
  },
  emits: ['save'],
  async mounted() {
    if (!this.step_vertical) {
      await this.fetchStepData('vertical')
    }
    await Promise.all([
      this.fetchRecognitionClasses(),
      this.fetchCategories(),
      this.fetchCodecs(),
      this.fetchCheckinStayMode(),
      this.fetchAnonymizeMode(),
      this.fetchExperienceType(),
      this.fetchPurchaseTime(),
      this.fetchDisplayTime(),
      this.fetchProcessingPriority(),
    ])
    this.onReset()
  },
  computed: {
    ...mapGetters('core', [
      'recognitionClasses',
      'categories',
      'codecs',
      'checkinStayMode',
      'anonymizeMode',
      'experienceType',
      'purchaseTime',
      'displayTime',
      'processingPriority',
    ]),
    ...mapGetters('eventWizard', ['isStepLoading', 'step_vertical']),
    loading() {
      return this.isStepLoading('vertical')
    },
  },
  methods: {
    ...mapActions('core', [
      'fetchRecognitionClasses',
      'fetchCategories',
      'fetchCodecs',
      'fetchCheckinStayMode',
      'fetchAnonymizeMode',
      'fetchExperienceType',
      'fetchPurchaseTime',
      'fetchDisplayTime',
      'fetchProcessingPriority',
    ]),
    ...mapActions('eventWizard', ['fetchStepData']),
    onReset() {
      if (this.step_vertical) {
        this.form = {...this.step_vertical}
      }
    },
    async onSave() {
      await this.emitPromised('save', this.form)
      this.onReset()
    },
  }
}
</script>
